import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import "../Css/Sidebar2.css";
import { Avatar } from "@material-ui/core";
import { Text, tid } from "../containers/Language";

const Follower = ({ username, user, photoURL }) => {
  const [isDark, setIsDark] = React.useState(false);

  return (
    <div className={`${
      isDark ? "dark" : ""
    } container_sidebar dark:bg-dark-300 text-black dark:text-white `}
    >
      <article className="card_sidebar">
        <Avatar src={user?.photoURL} alt="new" />
        <h4>Example Name</h4>
        <a href="#" className="btn_sidebar">
        <Text tid="View_Profile" />

        </a>
      </article>

      <article className="card_sidebar">
        <Avatar src={user?.photoURL} alt="new" />
        <h4>{user?.displayName}</h4>
        <a href="#" className="btn_sidebar">
          <Text tid="View_Profile" />
        </a>
      </article>

    </div>
  );
};

export default Follower;
